// VORLICH — global AJAX cart + slide-in drawer + live count + free-shipping bar.
(function () {
  var drawer = document.getElementById('cartDrawer');
  if (!drawer) return;
  var itemsEl = document.getElementById('cdItems'),
      subEl = document.getElementById('cdSubtotal'),
      shipEl = document.getElementById('cdShip'),
      closeBtn = document.getElementById('cdClose'),
      backdrop = document.getElementById('cdBackdrop');
  var threshold = parseFloat(drawer.dataset.threshold || '0');
  var lastFocus = null;

  function money(cents, cur) {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur || 'GBP' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }
  function openD() {
    lastFocus = document.activeElement; drawer.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    if (closeBtn) closeBtn.focus();
  }
  function closeD() {
    drawer.hidden = true; document.documentElement.style.overflow = '';
    if (lastFocus) { try { lastFocus.focus(); } catch (e) {} }
  }
  if (closeBtn) closeBtn.addEventListener('click', closeD);
  if (backdrop) backdrop.addEventListener('click', closeD);
  drawer.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeD(); });

  function updateCounts(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = '(' + n + ')'; });
  }
  function thumb(src) { return src ? src.replace(/(\.(?:jpg|jpeg|png|webp|gif))(\?|$)/i, '_120x120_crop_center$1$2') : ''; }

  function render(cart) {
    updateCounts(cart.item_count);
    if (!cart.items.length) {
      itemsEl.innerHTML = '<p class="cd__empty">Your cart is empty.</p>';
    } else {
      itemsEl.innerHTML = cart.items.map(function (it) {
        var img = it.image ? '<img src="' + thumb(it.image) + '" alt="" width="60" height="60" loading="lazy">' : '';
        var opt = (it.variant_title && it.variant_title !== 'Default Title') ? '<span class="cd__opt">' + it.variant_title + '</span>' : '';
        return '<div class="cd__it" data-key="' + it.key + '">' +
          '<div class="cd__img">' + img + '</div>' +
          '<div class="cd__meta"><a href="' + it.url + '">' + it.product_title + '</a>' + opt +
          '<div class="cd__qrow"><div class="cd__q"><button type="button" data-dec aria-label="Decrease quantity">–</button><span>' + it.quantity + '</span><button type="button" data-inc aria-label="Increase quantity">+</button></div>' +
          '<span class="cd__lp">' + money(it.final_line_price, cart.currency) + '</span></div></div>' +
          '<button type="button" class="cd__rm" data-rm aria-label="Remove ' + it.product_title + '">Remove</button>' +
          '</div>';
      }).join('');
    }
    subEl.textContent = money(cart.total_price, cart.currency);
    if (threshold > 0) {
      shipEl.hidden = false;
      var thc = threshold * 100, rem = thc - cart.total_price;
      if (rem > 0) {
        shipEl.innerHTML = '<div class="cd__shiptext">Spend <b>' + money(rem, cart.currency) + '</b> more for free shipping</div>' +
          '<div class="cd__bar"><span style="width:' + Math.min(100, (cart.total_price / thc) * 100) + '%"></span></div>';
      } else {
        shipEl.innerHTML = '<div class="cd__shiptext">✓ You’ve unlocked <b>free shipping</b></div><div class="cd__bar"><span style="width:100%"></span></div>';
      }
    }
    bindItemButtons();
  }
  function fetchCart(cb) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { render(c); if (cb) cb(c); });
  }
  function change(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(render);
  }
  function bindItemButtons() {
    itemsEl.querySelectorAll('.cd__it').forEach(function (row) {
      var key = row.dataset.key, q = parseInt(row.querySelector('.cd__q span').textContent, 10);
      var inc = row.querySelector('[data-inc]'), dec = row.querySelector('[data-dec]'), rm = row.querySelector('[data-rm]');
      if (inc) inc.onclick = function () { change(key, q + 1); };
      if (dec) dec.onclick = function () { change(key, q - 1); };
      if (rm) rm.onclick = function () { change(key, 0); };
    });
  }

  // Intercept every add-to-cart form (PDP, sticky, quick-add, cross-sell, gift-finder).
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action || f.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var btn = f.querySelector('[type=submit]');
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(f) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (btn) btn.disabled = false;
        if (!res.ok) { if (window.location) window.location = '/cart'; return; }
        fetchCart(openD);
      })
      .catch(function () { if (btn) btn.disabled = false; });
  }, true);

  // Cart link opens the drawer instead of navigating.
  document.querySelectorAll('[data-cart-link]').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); fetchCart(openD); });
  });

  // Keep the header count accurate on load.
  fetchCart();
})();
